import React, { useState } from "react";
import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Input,
    InputGroup,
    InputRightAddon,
    Icon,
    TableContainer,
    VStack,
    HStack,
    SimpleGrid,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const PAGE_SIZE = 10;

const outcomesData = [
    {
        game: "Leicester City VS Newcastle United",
        date: "2025-04-07 07:00 PM",
        market: "Head to Head",
        totalBets: 1,
        winOutcome: "Leicester City",
    },
    {
        game: "Manchester United VS Manchester City",
        date: "2025-04-06 03:30 PM",
        market: "Spreads",
        totalBets: 1,
        winOutcome: "Manchester United",
    },
    {
        game: "Tottenham Hotspur VS Southampton",
        date: "2025-04-06 01:00 PM",
        market: "Totals",
        totalBets: 1,
        winOutcome: "Over",
    },
];

const DeclaredOutcomes = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const filtered = outcomesData.filter((o) =>
        o.game.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const start = (page - 1) * PAGE_SIZE;
    const data = filtered.slice(start, start + PAGE_SIZE);
    const SIDEBAR_WIDTH = "240px";

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="gray.50"
                minH="100vh"
                mt="64px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex
                    mb={8}
                    justify="space-between"
                    align={{ base: "stretch", md: "center" }}
                    direction={{ base: "column", md: "row" }}
                    gap={3}
                >
                    <Text fontSize="2xl" fontWeight="semibold" color="#1a202c">
                        Declared Outcomes
                    </Text>

                    <InputGroup maxW={{ base: "100%", md: "300px" }} size="md">
                        <Input
                            bg="white"
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            borderRight="none"
                            _focus={{ borderColor: "#4c1d95", boxShadow: "none" }}
                        />
                        <InputRightAddon
                            bg="#4f46e5"
                            cursor="pointer"
                            _hover={{ bg: "#4338ca" }}
                        >
                            <Icon as={SearchIcon} color="white" />
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                {/* TABLE SECTION */}
                <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0" display={{ base: "none", md: "block" }}>
                    <TableContainer>
                        <Table variant="simple">
                            <Thead bg="#4f46e5">
                                <Tr h="50px">
                                    <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" borderTopLeftRadius="lg">Game</Th>
                                    <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" textAlign="center">Market</Th>
                                    <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" textAlign="center">Total Bets</Th>
                                    <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" textAlign="right" borderTopRightRadius="lg">Win Outcome</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((o, index) => (
                                    <Tr key={index} _hover={{ bg: "gray.50" }}>
                                        <Td>
                                            <Text fontSize="sm" fontWeight="medium" color="gray.700">
                                                {o.game}
                                            </Text>
                                            <Text fontSize="xs" color="gray.500">
                                                {o.date}
                                            </Text>
                                        </Td>
                                        <Td fontSize="sm" color="gray.600" textAlign="center">
                                            {o.market}
                                        </Td>
                                        <Td fontSize="sm" color="gray.600" textAlign="center">
                                            {o.totalBets}
                                        </Td>
                                        <Td fontSize="sm" fontWeight="medium" color="gray.700" textAlign="right">
                                            {o.winOutcome}
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* Mobile View */}
                <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
                    {data.map((o, index) => (
                        <Box key={index} bg="white" p={4} borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.200">
                            <Text fontWeight="bold" fontSize="md" mb={1}>{o.game}</Text>
                            <Text fontSize="xs" color="gray.500" mb={3}>{o.date}</Text>

                            <SimpleGrid columns={2} spacing={4} mb={4}>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Market</Text>
                                    <Text fontSize="sm" fontWeight="500">{o.market}</Text>
                                </Box>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Total Bets</Text>
                                    <Text fontSize="sm" fontWeight="500">{o.totalBets}</Text>
                                </Box>
                            </SimpleGrid>

                            <Flex justify="space-between" align="center" pt={3} borderTop="1px solid" borderColor="gray.100">
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Win Outcome</Text>
                                    <Text fontSize="sm" fontWeight="bold" color="green.600">{o.winOutcome}</Text>
                                </Box>
                            </Flex>
                        </Box>
                    ))}
                </VStack>
            </Box>
        </>
    );
};

export default DeclaredOutcomes;
